import React, { Component } from 'react';
// Composants
import { Label, Menu, Popup } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SyncModal from './SyncModal';
// Librairies
import { connect } from 'react-redux';
import i18n from '../../locales/i18n';
import { faArrowsRotate, faCloudCheck, faTriangleExclamation, faWifiSlash } from '@fortawesome/pro-solid-svg-icons';

// Indicateur de synchro des barres ; hors-ligne v2 inactif (sync null) : seul l'état « hors ligne » s'affiche
class SyncIndicator extends Component {
    state = {
        isModalOpen: false
    };

    render() {
        const { isOnline, sync } = this.props;
        if (!sync && isOnline) return null;
        const { icon, color, spin, count, label } = this.getAppearance();

        return (
            <>
                <Popup
                    position='bottom center' content={label} style={{ zIndex: 700 }}
                    trigger={
                        <Menu.Item aria-label={label} style={{ position: 'relative' }} onClick={() => sync && this.setState({ isModalOpen: true })}>
                            <FontAwesomeIcon icon={icon} spin={spin} style={{ color }} />
                            {count > 0 && <Label circular size='mini' floating style={{ top: '4px', left: 'auto', right: '0' }}>{count}</Label>}
                        </Menu.Item>
                    }
                />
                {sync && this.state.isModalOpen && <SyncModal onClose={() => this.setState({ isModalOpen: false })} />}
            </>
        );
    }

    // Icône, couleur, pastille et texte, du plus grave au plus calme
    getAppearance = () => {
        const { isOnline, sync } = this.props;
        const waiting = (sync?.pending || 0) + (sync?.sending || 0);
        const problems = (sync?.failed || 0) + (sync?.blocked || 0);
        // Formes _one / _many / _other écrites à la main dans fr-BE.json
        if (problems > 0)
            return { icon: faTriangleExclamation, color: 'var(--red-100)', count: problems, label: i18n.t("{{count}} saisie en échec : ouvrir la synchronisation", { count: problems }) };
        if (!isOnline)
            return { icon: faWifiSlash, color: 'var(--red-100)', count: waiting, label: waiting ? i18n.t("Hors ligne : {{count}} saisie en attente", { count: waiting }) : i18n.t("Hors ligne") };
        if (sync?.sending)
            return { icon: faArrowsRotate, color: 'var(--blue-100)', spin: true, count: waiting, label: i18n.t("Synchronisation en cours ({{nb}})", { nb: waiting }) };
        if (waiting)
            return { icon: faArrowsRotate, color: 'var(--orange-100)', count: waiting, label: i18n.t("{{count}} saisie en attente d'envoi", { count: waiting }) };
        return { icon: faCloudCheck, color: 'var(--green-100)', count: 0, label: i18n.t("Tout est synchronisé") };
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.isOnline,
        sync: state.sync
    };
};

export default connect(mapStateToProps)(SyncIndicator);
